import { render, staticRenderFns } from "./SaveLinkButton.vue?vue&type=template&id=5e99787d&"
import script from "./SaveLinkButton.vue?vue&type=script&lang=js&"
export * from "./SaveLinkButton.vue?vue&type=script&lang=js&"
import style0 from "./SaveLinkButton.vue?vue&type=style&index=0&id=5e99787d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports